export default __webpack_public_path__ + "static/media/gallery04.a4ecfe60.webp";